import React, { PureComponent } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import * as DeviceGroupsActions from '../../../actions/deviceGroups';
import * as CountriesActions from '../../../actions/countries';
import FilterFormDom from '../../../components/Screens/Estate/EstateList/Forms/FilterForm';
import * as ChainsActions from '../../../actions/chains';

class FilterForm extends PureComponent {
  static propTypes = {
    isOpen: PropTypes.bool,
    fetchDeviceGroups: PropTypes.func.isRequired,
    onClickCancel: PropTypes.func.isRequired,
    saveFilters: PropTypes.func.isRequired,
    filters: PropTypes.shape({
      mode: PropTypes.string.isRequired,
      groupsToFilter: PropTypes.arrayOf(
        PropTypes.oneOfType([PropTypes.string, PropTypes.number])
      ).isRequired,
      statusToFilter: PropTypes.arrayOf(PropTypes.string).isRequired,
      countriesToFilter: PropTypes.arrayOf(PropTypes.string).isRequired,
      chainsToFilter: PropTypes.arrayOf(PropTypes.string),
    }).isRequired,
    onlyByDevice: PropTypes.bool,
    fetchCountries: PropTypes.func.isRequired,
    fetchChains: PropTypes.func.isRequired,
    countries: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    chains: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    deviceGroups: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    clearFilters: PropTypes.func,
    isActiveFilters: PropTypes.bool,
  };

    static defaultProps = {
        isOpen: false,
        onlyByDevice: false,
        clearFilters: null,
        isActiveFilters: false,
    }

    constructor(props) {
        super(props)

    this.state = {
      form: {
        countries: [],
        chains: [],
        deviceGroups: [],
        migrated: true,
        mode: props.filters.mode,
        selectedCountries: [],
        selectedChains: [],
        selectedGroups: [],
        selectedStatus: [],
        showEmptyStores: false,
      },
      fetchingData: true,
    };
  }

  async componentDidUpdate(prevProps) {
    const { isOpen, fetchDeviceGroups, filters, fetchCountries, fetchChains } =
      this.props;
    const { mode } = filters;
    const { isOpen: wasOpen } = prevProps;

    if (isOpen && isOpen !== wasOpen) {
      await Promise.all([fetchDeviceGroups(), fetchCountries(), fetchChains()]);

            // As we are comparing the actual props with the prevProps to avoid infinite loops, we can use setState inside componentDidUpdate
            // eslint-disable-next-line react/no-did-update-set-state
            this.buildForm(mode)
        }
    }

  buildForm = (mode) => {
    const {
      filters: {
        countriesToFilter: selectedCountries,
        chainsToFilter: selectedChains,
        groupsToFilter: selectedGroups,
        migrated,
        showEmptyStores,
        statusToFilter: selectedStatus,
      },
      countries,
      chains,
      deviceGroups,
    } = this.props;
    this.setState({
      form: {
        countries,
        chains,
        deviceGroups,
        migrated,
        mode,
        selectedCountries,
        selectedChains,
        selectedGroups,
        selectedStatus,
        showEmptyStores,
      },
      fetchingData: false,
    });
  };

    onChangeFormValue = ({ target: { name, value } }) => {
        const { form } = this.state
        this.setState({ form: { ...form, [name]: value } })
    }

    onClickCancel = () => {
        const { onClickCancel } = this.props
        this.setState({ fetchingData: true }, onClickCancel)
    }

    onClickSubmit = () => {
        const { saveFilters } = this.props
        const { form } = this.state
        this.setState({ fetchingData: true }, () => saveFilters(form))
    }

    render() {
        const { isOpen, onlyByDevice, clearFilters, isActiveFilters } = this.props
        const { fetchingData, form } = this.state
        return (
            <FilterFormDom
                ref={this.inputToFocus}
                isOpen={isOpen}
                onChangeForm={this.onChangeFormValue}
                onClickCancel={this.onClickCancel}
                onClickSubmit={this.onClickSubmit}
                fetchingData={fetchingData}
                form={form}
                onlyByDevice={onlyByDevice}
                clearFilters={clearFilters}
                isActiveFilters={isActiveFilters}
            />
        )
    }
}

const mapStateToProps = ({
  countries: { countries },
  chains: { chains },
  device: { displayGroups: deviceGroups },
}) => ({
  countries,
  chains,
  deviceGroups,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ...DeviceGroupsActions,
      ...CountriesActions,
      ...ChainsActions,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(FilterForm);
